import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/apps/play-portal/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/apps/play-portal/src/app/games/(details)/[uid]/game-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/apps/play-portal/src/app/games/(details)/game-details-v2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageBackground"] */ "/home/runner/_work/play/play/apps/play-portal/src/components/ui/custom/image-background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/node_modules/@mui/icons-material/esm/Telegram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/node_modules/@mui/icons-material/esm/X.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/play/play/node_modules/@mui/material/SvgIcon/SvgIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/home/runner/_work/play/play/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/home/runner/_work/play/play/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/home/runner/_work/play/play/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/play/play/node_modules/next/dist/client/script.js");
